import React from "react";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: "sm" | "md";
}

const Toggle: React.FC<ToggleProps> = ({ checked, onChange, disabled = false, size = "md" }) => {
  const isMd = size === "md";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      className={`relative inline-flex shrink-0 rounded-full transition-colors duration-200 focus:outline-none ${
        isMd ? "h-6 w-12" : "h-5 w-10"
      } ${
        checked
          ? "bg-emerald-600"
          : "bg-slate-300"
      } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
    >
      <span
        className={`pointer-events-none absolute rounded-full bg-white shadow-sm transition-[left] duration-200 ${
          isMd ? "top-1 h-4 w-4" : "top-[3px] h-3.5 w-3.5"
        }`}
        style={{
          left: checked ? (isMd ? 30 : 24) : 2,
        }}
      />
    </button>
  );
};

export default Toggle;
